import { createSlice } from "@reduxjs/toolkit";
import { sortAllView } from "../utils";
import { boardViewForAllocation } from "./TransferOrderSliceV2";

const pricelistDefaultColumns = [
  "PRICELIST NAME",
  "COUNTRY",
  "CHANNEL",
  "SUPPLYING FACILITY",
  "VALIDITY DATE",
  "STATUS",
];

const initialState = {
  pricelists: { count: 0, results: [] },
  pricelistParams: { limit: 10, offset: 0 },
  priceListsSelection: [],
  pricelistLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: pricelistDefaultColumns,
      allViews: {
        "Default View": pricelistDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },
};

const pricingSlice = createSlice({
  name: "pricing",
  initialState,
  reducers: {
    setPricelists: (state, action) => {
      state.pricelists = action.payload;
    },
    setPriceListsSelection: (state, action) => {
      state.priceListsSelection = action.payload;
    },
    setPricelistParams: (state, action) => {
      state.pricelistParams = action.payload;
    },
    updatePricelistParams: (state, action) => {
      state.pricelistParams = { ...state.pricelistParams, ...action.payload };
    },
    resetPricelistParams: state => {
      state.pricelistParams = { limit: state.pricelistParams.limit, offset: 0 };
    },
    setPricelistLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.pricelistLayout = {
        ...state.pricelistLayout,
        listView: {
          ...state.pricelistLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.pricelistLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
  },
});

export const {
  setPricelists,
  setPricelistParams,
  setPriceListsSelection,
  updatePricelistParams,
  resetPricelistParams,
  setPricelistLayoutAllViews,
} = pricingSlice.actions;

export default pricingSlice.reducer;
